import { OrderedMap, Record } from 'immutable';
const AuthorsRecord = Record({
  authors: OrderedMap(),
  error: undefined,
  isRequesting: false,
  lastLoaded: null
});
export default AuthorsRecord;